import { Injectable } from '@angular/core';
import { DatePipe   } from '@angular/common';
import { isEmpty } from 'rxjs/operators';
import { SlotVisibility } from 'src/app/beans/slot/slot.visibility.bean';
import { DateUtil } from 'src/app/utils/date.util';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';


@Injectable({
  providedIn: 'root'
})
export class SortingPipe
{
  constructor
  (
      private _datePipe: DatePipe,
      private _utils : UtilsManager
  ){}

  sort(a: any, b: any)
  {
    if(a > b){
      return 1
    }
    if(a < b){
      return -1
    }
    return 0
  }
}
